import { configureStore } from '@reduxjs/toolkit';

import { environment } from '@paragon/environment-tools';
import { logInData } from '@paragon/login-tools';
import { notifications } from '@paragon/notification-tools';
import { spinnerMessages } from '@paragon/task-spinner';
import { theme } from '@paragon/themes';

import { alertBox } from './alertBoxSlice';
import { grid } from './gridSlice';
import { jobs } from './jobsSlice';
import { organizations } from './organizationsSlice';
import { regions } from './regionsSlice';
import { statuses } from './statusesSlice';
import { views } from './viewsSlice';

export const store = configureStore({
  reducer: {
    environment,
    logInData,
    spinnerMessages,
    theme,
    notifications,

    alertBox,
    grid,
    jobs,
    organizations,
    regions,
    statuses,
    views,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
